// extracted by mini-css-extract-plugin
export default {"root":"Player-detail_root__BT1fO","content":"Player-detail_content__Zmij-","title":"Player-detail_title__5onf7","item":"Player-detail_item__o5i1S"};